module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.13667/img/business-types/nonprofit-education.png"